import { SpintrTypes } from "src/typings";

// With the `drive.file` scope the Drive API only returns metadata for files the
// current user has previously opened through this app, so attached Google Drive
// files are rendered as direct links composed from the stored external id
// instead of fetching metadata (which would 404 for most users).

// Ids that came from the old file browser are stored as "driveId|fileId";
// ids from the Google Picker are the bare file id.
export function getGoogleDriveFileId(externalId: string): string {
    const separatorIndex = externalId.indexOf("|");
    return separatorIndex === -1 ? externalId : externalId.substring(separatorIndex + 1);
}

// Works for both files and folders; Google redirects to the right viewer/editor.
export function getGoogleDriveUrl(externalId: string): string {
    return `https://drive.google.com/open?id=${encodeURIComponent(getGoogleDriveFileId(externalId))}`;
}

// Fallback display name when only the id is stored (the post/page data doesn't
// carry the file name).
export const googleDriveFallbackName = "Google Drive";

export function isGoogleDriveSource(source: string | number): boolean {
    return parseInt(source as string, 10) === SpintrTypes.FolderRootSource.GoogleDrive;
}

export interface IGoogleDriveLinkItem {
    id: string;
    name: string;
    webUrl: string;
    isDirectory?: boolean;
}

// The pre-resolved item consumers render instead of fetching Drive metadata.
export function toGoogleDriveItem(externalId: string, name?: string, isDirectory?: boolean): IGoogleDriveLinkItem {
    return {
        id: externalId,
        name: name || googleDriveFallbackName,
        webUrl: getGoogleDriveUrl(externalId),
        isDirectory,
    };
}
